import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import { DragDropContext, Droppable } from 'react-beautiful-dnd'

import '../../assets/css/presentation.css'
import { isEmpty } from '../helpers'

import AdvancedSlideConfigModal from './components/AdvancedSlideConfigModal'
import GlobalSettingsModal from './components/GlobalSettingsModal'
import SlideConfig from './components/SlideConfig'
import Button from '../../UniformComponents/Button'
import SubmitModal from './components/SubmitModal'
import PresentationStore from './PresentationStore'
import Switch from '../../UniformComponents/Switch'
import PresentationLayout from './components/PresentationLayout/PresentationLayout'
import Spinner from '../../UniformComponents/Spinner'

@observer
class Presentation extends Component {
    constructor(props) {
        super(props)
        this.state = {
            globalYears: [],
            globalBenchmarks: [],
            slideConfigs: [],
            isOpenAll: false,
            globalSettingsModalStatus: false,
            submitModalStatus: false,
            surveyLoaded: false,
            submitLoading: false,
            surveyLoading: true,
            adminInfo: false,

            deleteSlidesModalStatus: false,
            deleteIndex: null,
            derivedOptions: [],
            inheritedOptions: [],
            kpiOptions: [],
            crossBreakSubQuestionOptions: [],
            reset: false,
            downloadComplete: false,
        }

        this.submitStatus = null
        this.res = null
        this.presentationStore = new PresentationStore()
    }

    async componentDidMount() {
        const copyOfState = { ...this.state }
        const { store } = this.props
        await this.presentationStore.presentationInitialState(copyOfState, store)

        copyOfState.surveyLoading = false
        copyOfState.surveyLoaded = true

        this.setState(copyOfState)
    }

    globalYearSettingUpdater= ({ value, name }) => {
        const copyOfState = this.presentationStore
            .globalYearsSettingUpdater(value, name, this.state)
        this.setState(copyOfState)
    }

    globalBenchmarkSettingUpdater= ({ value, name }) => {
        const copyOfState = this.presentationStore
            .globalBenchmarksSettingUpdater(value, name, this.state)
        this.setState(copyOfState)
    }

    duplicateSlide = (index) => {
        const copyOfState = this.presentationStore.duplicateSlide(index, this.state)
        this.setState(copyOfState)
    }

    addSlideConfig = () => {
        const { advancedSlidesItems, addSlideConfig } = this.presentationStore
        advancedSlidesItems.forEach((questionTypeCode) => addSlideConfig(
            questionTypeCode, false, false, { pageQUestionId: '' },
        ))
    }

    onDragEnd = (result) => {
        const copyOfState = this.presentationStore.onDragEnd(result, this.state)
        this.setState(copyOfState)
    }

    submitPowerpoint = async (useNewEndpoint = false) => {
        this.submitStatus = 'loading'
        this.setState({ submitModalStatus: true, submitLoading: true, downloadComplete: false })
        try {
            const obj = await this.presentationStore.submitPowerpoint(null, null, useNewEndpoint)
            this.res = obj.resp
            this.submitStatus = obj.submitStatus
        } catch (e) {
            console.error(e)
            this.res = e.resp
            this.submitStatus = e.submitStatus
        }

        this.setState({ submitLoading: false, submitModalStatus: true, downloadComplete: true })
    }

    // Remove modal for question deletion for now

    handleGlobalSettingsModal = () => {
        const { globalSettingsModalStatus } = this.state
        this.setState({ globalSettingsModalStatus: !globalSettingsModalStatus })
    }

    handleSubmitModal = () => {
        const { submitModalStatus } = this.state
        this.setState({ submitModalStatus: !submitModalStatus })
    }

    toggleAdminInfo = () => {
        const { adminInfo } = this.state
        this.setState({ adminInfo: !adminInfo })
    }

    renderGuide = () => (
        <Fragment>
            <p>
                <span>Presentation</span>
                {' '}
                Lorem ipsum dolor sit amet, consectetur
                {' '}
                adipiscing elit, sed do eius mod tempor
            </p>
            <p>
                incididunt ut labore et dolore magna aliqua.
                {' '}
                Ut enim ad minim veniam dolor sita
            </p>
        </Fragment>
    )

    renderButtons = () => {
        const { store } = this.props
        return (
            <div className="buttons-presentation">
                <Button
                    onClick={this.presentationStore.toggleAdvancedSlidesModal}
                    cssClass="primary icon-btn uper-panel-button"
                    icon="fa-light fa-circle-plus"
                >
                    {i18n.t('presentation.advancedSlides')}
                </Button>
                <Button
                    onClick={() => this.submitPowerpoint()}
                    cssClass="secondary icon-btn uper-panel-button"
                    icon="fal fa-presentation-screen"
                >
                    {i18n.t('presentation.createPPT')}
                </Button>
                {store.isExploriStaff() && (
                    <Button
                        onClick={() => this.submitPowerpoint(true)}
                        cssClass="secondary icon-btn uper-panel-button"
                        icon="fal fa-presentation-screen"
                    >
                        {i18n.t('presentation.createPPT')}
                        {' '}
                        (NEW)
                    </Button>
                )}
            </div>
        )
    }

    renderFilterOptions = () => {
        const { store } = this.props
        const { globalBenchmarks, globalYears } = this.presentationStore
        return (
            <div>
                <GlobalSettingsModal
                    handleGlobalSettingsModal={this.handleGlobalSettingsModal}
                    modalStatus
                    presentationStore={this.presentationStore}
                    globalBenchmarkSettingUpdater={this.globalBenchmarkSettingUpdater}
                    globalYearSettingUpdater={this.globalYearSettingUpdater}
                    benchmarkPeriods={store.benchmarkPeriods}
                    benchmarkPeriodUpdater={this.presentationStore.benchmarkPeriodUpdater}
                />
            </div>
        )
    }

    renderSurveyDetails = () => {
        const { store } = this.props
        return (
            <div>
                <div>
                    <span className="survey-title">{store.survey.title}</span>
                </div>
                <div>
                    <Switch
                        onToggle={this.presentationStore.minimiseAllHandler}
                        label="Expand all questions"
                        cssClass="switch-button-presentation"
                    />
                </div>
            </div>

        )
    }

    resetFilters = () => {
        const copyOfState = this.presentationStore.resetGlobalSettings(this.state)
        this.setState(copyOfState)
    }

    renderPresentation = () => {
        const { store } = this.props
        const {
            surveyLoading,
            kpiOptions,
            crossBreakSubQuestionOptions,
            derivedOptions,
            inheritedOptions,
            adminInfo,
            advancedSlidesModalStatus,
            kpis,
            submitModalStatus,
            downloadComplete,
        } = this.state
        const { globalYears, globalBenchmarks, slideConfigs } = this.presentationStore
        let presentation

        if (surveyLoading) {
            presentation = (
                <div className="presentation-main-col">
                    <div>
                        <div>
                            <h2>Survey loading</h2>
                        </div>
                    </div>
                </div>
            )
        } else {
            presentation = (
                <div className="presentation-main-col">
                    {((store.tokenData.isAdmin) && <div onClick={this.toggleAdminInfo} className="admin-info-btn" />)}
                    <DragDropContext onDragEnd={this.onDragEnd}>
                        <Droppable droppableId="question-list" type="question-list">
                            {(provided) => (
                                <div
                                    ref={provided.innerRef}
                                    {...provided.droppableProps}
                                >
                                    {slideConfigs.map((q, i) => (
                                        <SlideConfig
                                            kpiOptions={kpiOptions}
                                            crossBreakSubQuestionOptions={
                                                crossBreakSubQuestionOptions
                                            }
                                            derivedOptions={derivedOptions}
                                            inheritedOptions={inheritedOptions}
                                            globalYears={globalYears}
                                            globalBenchmarks={globalBenchmarks}
                                            benchmarks={q.benchmarks}
                                            config={q}
                                            type={q.question.questionTypeCode}
                                            removeSlideConfig={this.presentationStore.removeSlideConfig}
                                            duplicateSlide={this.duplicateSlide}
                                            // title={q.question.content.getTitleByLocale('shortTitle', 'en_GB', 'en_GB')}
                                            key={q.slide.id}
                                            index={i}
                                            adminInfo={adminInfo}
                                            presentationStore={this.presentationStore}
                                        />
                                    ))}
                                    {provided.placeholder}
                                </div>
                            )}
                        </Droppable>
                    </DragDropContext>

                    <AdvancedSlideConfigModal
                        handleAdvancedSlidesModal={this.handleAdvancedSlidesModal}
                        modalStatus={advancedSlidesModalStatus}
                        addSlideConfig={this.addSlideConfig}
                        haveKpiOptions={(!isEmpty(kpiOptions))}
                        haveDerivedOptions={(!isEmpty(derivedOptions))}
                        haveInheritedOptions={(!isEmpty(inheritedOptions))}
                        kpis={kpis}
                        slideConfigs={slideConfigs}
                        presentationStore={this.presentationStore}
                    />
                    <SubmitModal
                        handleSubmitModal={this.handleSubmitModal}
                        modalStatus={submitModalStatus}
                        response={this.res}
                        status={this.submitStatus}
                        presentationStore={this.presentationStore}
                        handleDownload={this.submitPowerpoint}
                        downloadComplete={downloadComplete}
                    />
                </div>
            )
        }
        return presentation
    }

    render() {
        const { submitLoading, surveyLoading } = this.state
        if (surveyLoading) {
            return (
                <div className="presentation" style={{ paddingTop: 78 }}>
                    <div className="surveyBuilder">
                        <Spinner cssClass="loading-spinner" />
                    </div>
                </div>
            )
        }
        return (
            <div className="presentation" style={{ paddingTop: 78 }}>
                <div className="surveyBuilder">
                    {surveyLoading ? <Spinner cssClass="loading-spinner" /> : null}
                    {submitLoading ? <div className="overlay"><div className="loader" /></div> : null}
                    <PresentationLayout
                        pageTitle="Global Settings"
                        renderFilterOptions={this.renderFilterOptions}
                        renderButtons={this.renderButtons}
                        renderPresentationPanel={this.renderPresentation}
                        renderGuide={false}
                        surveyTitle={this.renderSurveyDetails}
                        resetFilters={this.resetFilters}
                    />
                </div>
            </div>
        )
    }
}

export default Presentation
